module.exports = __webpack_public_path__ + "static/Konditor Seite 2-b09b74ff49eb6d6a9f448bd8e5d7a8d2.jpg";